import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { RiCollapseDiagonalLine } from "react-icons/ri";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { FaFilter } from "react-icons/fa";
import { TbReload } from "react-icons/tb";
import { TbArrowsSort } from "react-icons/tb";
import { IoIosArrowForward } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import { RiDeleteBin5Line } from "react-icons/ri";

const API_URL = process.env.REACT_APP_API_BASE || "https://wa-api.globebot.io";

function decodeToken(token) {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        return null;
    }
}

function UnsubscribedNumbers() {
    const [showfilter, setshowfilter] = useState(false);
    const [WABANumber, setWABANumber] = useState('');
    const [MobileNumber, setMobileNumber] = useState('');
    const [unsubscribes, setUnsubscribes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const [userToken] = useState(localStorage.getItem('token') || '');
    const [wabaId, setWabaId] = useState('');

    useEffect(() => {
        // try to get wabaId from token if present
        if (userToken) {
            const decoded = decodeToken(userToken);
            if (decoded && decoded.wabaId) {
                setWabaId(decoded.wabaId);
            }
        }
    }, [userToken]);

    useEffect(() => {
        if (wabaId) {
            fetchData();
        }
        // eslint-disable-next-line
    }, [wabaId, refresh]);

    const fetchData = async (opts = {}) => {
        setLoading(true);
        try {
            const params = new URLSearchParams();
            params.append('wabaId', opts.wabaId || wabaId);
            if (opts.MobileNumber !== undefined) {
                if (opts.MobileNumber) {
                    params.append('number', opts.MobileNumber);
                }
            } else if (MobileNumber) {
                params.append('number', MobileNumber);
            }
            // Note: Backend route: /unsubscribe [get], filtered by wabaId, number

            const res = await fetch(`${API_URL}/api/user/unsubscribe?${params.toString()}`, {
                headers: {
                    'Authorization': userToken ? `Bearer ${userToken}` : undefined,
                }
            });
            const data = await res.json();
            if (data.success && Array.isArray(data.data)) {
                setUnsubscribes(data.data);
            } else {
                setUnsubscribes([]);
            }
        } catch (error) {
            setUnsubscribes([]);
        }
        setLoading(false);
    };

    const getdata = () => {
        fetchData({ wabaId, MobileNumber });
    };

    const clearFilter = () => {
        setWABANumber('');
        setMobileNumber('');
        // fetch all with only wabaId
        fetchData({ wabaId, MobileNumber: '' });
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this unsubscribe entry?')) return;
        setLoading(true);
        try {
            const res = await fetch(`${API_URL}/api/user/unsubscribe/${id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': userToken ? `Bearer ${userToken}` : undefined,
                    'Content-Type': 'application/json'
                }
            });
            const data = await res.json();
            if (data.success) {
                setRefresh(r => !r); // Refetch
            } else {
                alert(data.error || 'Failed to delete entry');
            }
        } catch (e) {
            alert('Something went wrong.');
        }
        setLoading(false);
    };

    // Optionally use WABANumber field for filtering if required
    // But backend expects wabaId.

    return (
        <>
            <div className='dark:bg-[#121519] bg-[#fff] min-h-screen w-[100%] px-4'>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1'>
                    <h1 className='text-[#000] font-semibold text-[20px] flex gap-1 items-center dark:text-[#fff]'>
                        <Link to='/Configuration'> <FaArrowLeftLong /></Link>
                        Unsubscribed Numbers
                    </h1>
                    <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>
                        <span>WhatsApp</span> <IoIosArrowForward />
                        <span>Report</span><IoIosArrowForward /> Unsubscribed Numbers
                    </div>
                </div>
                <div onClick={() => setshowfilter(!showfilter)}
                    className='w-[100%] flex justify-between  px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] mt-4'>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                        <RiCollapseDiagonalLine />
                        Filter Records
                    </div>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                        {showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
                    </div>
                </div>
                {showfilter &&
                    <div className='bg-[#edf1f5] py-2 px-4 w-[100%] dark:bg-[#121519]'>
                        <div className='w-[100%] flex flex-wrap gap-4'>

                            <div className='w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Mobile Number:</label>
                                <input
                                    value={MobileNumber}
                                    onChange={(e) => setMobileNumber(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    type="text"
                                />
                            </div>
                            <div className='w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>WABA Number:</label>
                                <input
                                    value={WABANumber}
                                    onChange={(e) => setWABANumber(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    type="text"
                                    disabled
                                    // backend does not filter by waba id string, it's fixed to user here
                                />
                            </div>


                            <div className='w-full sm:w-[48%] lg:w-[24%] flex items-center gap-1 mt-4'>
                                <button
                                    onClick={() => getdata()}
                                    className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'
                                    disabled={loading}
                                >
                                    <FaFilter /> <span className='text-[12px] font-bold'>Filter</span>
                                </button>

                                <button
                                    onClick={() => clearFilter()}
                                    className='flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
                                    disabled={loading}
                                >
                                    <TbReload /> <span className='text-[12px] font-bold'>Clear Filter</span>
                                </button>
                            </div>

                        </div>
                    </div>
                }
                <table className="w-full   overflow-hidden border-[1px] border-[#dee2e6] ">
                    <thead className="">
                        <tr className="text-left text-sm font-semibold text-gray-700">
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Number</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>WA Number</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Unsubscribed On</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Actions</span>
                                    {/* Remove Message Text, put Delete action */}
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
                                <td colSpan="4" className="p-2 text-[12px]">Loading...</td>
                            </tr>
                        ) : (
                            <>
                                {Array.isArray(unsubscribes) && unsubscribes.length > 0 ? unsubscribes.map((row, idx) => (
                                    <tr className="text-left text-gray-900 dark:text-[#fff] bg-[#f6f9fc] dark:bg-[#121519]" key={row.id || idx}>
                                        <td className="p-2 border-[1px] border-[#dee2e6] text-[12px]">{row.number}</td>
                                        <td className="p-2 border-[1px] border-[#dee2e6] text-[12px]">{row.wabaId}</td>
                                        <td className="p-2 border-[1px] border-[#dee2e6] text-[12px]">{row.createdAt ? new Date(row.createdAt).toLocaleString() : ''}</td>
                                        <td className="p-2 border-[1px] border-[#dee2e6] text-[12px]">
                                            <button
                                                onClick={() => handleDelete(row.id)}
                                                className="p-1 bg-[#e46262] rounded text-white hover:bg-[#d13434] flex items-center justify-center"
                                                title="Delete"
                                                disabled={loading}
                                            >
                                                <RiDeleteBin5Line />
                                            </button>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
                                        <td colSpan="4" className="p-1 text-[11px]">
                                            No unsubscribed numbers found.
                                        </td>
                                    </tr>
                                )}
                            </>
                        )}
                    </tbody>
                </table>
                <p className='text-[11px] text-[#3f7fc8] mt-2'>
                    Showing {unsubscribes.length === 0 ? 0 : 1} to {unsubscribes.length} of {unsubscribes.length} records
                </p>
            </div>
        </>
    );
}

export default UnsubscribedNumbers
